import { useEffect, useMemo } from 'react';
import { createContextForController } from 'react-controller-context';
import { useGradeLevels } from './use-grade-levels';
import { useStudents } from './use-students';
import { useGradYearState } from './use-grad-year-state';

const useController = () => {
    const {
        gradYears,
        getGradYearState,
        setGradYearState,
        resetGradYearStates
    } = useGradYearState(true);
    const {
        getGradYearLabel
    } = useGradeLevels();
    const { setStudentFilter } = useStudents();


    const visibileGradYears = useMemo(() => gradYears.filter(gradYear => getGradYearState(gradYear)), [getGradYearState, gradYears]);

    const toggleGradYearVisibility = setGradYearState;

    const resetVisibility = resetGradYearStates;

    useEffect(() => {
        setStudentFilter('gradYearVisibility', student => visibileGradYears.includes(student.gradYear));
    }, [visibileGradYears, setStudentFilter]);

    const getGradYearVisibility = getGradYearState;

    return {
        gradYears,
        getGradYearLabel,
        toggleGradYearVisibility,
        getGradYearVisibility,
        resetVisibility
    };
};

const context = createContextForController(useController);
export const GradYearVisibilityProvider = context.Provider;
export const useGradYearVisibility = context.useController;
